import React from 'react';
import { useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  StyledButton,
  Logo,
  StyledTypography,
  StyledSecondaryButton,
  StyledDialogCloseButton,
  StyledDialogActions,
} from './styles.js';

import LogoIcon from '../../../assets/logo_mais_vendas.png';

const SocialReminderModal = ({ open, onClose,onConfirm }) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  
  return (
    <StyledDialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <StyledDialogContent>
        <StyledDialogCloseButton onClick={onClose}>
          <CloseIcon />
        </StyledDialogCloseButton>

        <Logo component="img" image={LogoIcon} />

        <StyledDialogTitle>
          SUAS REDES SOCIAIS ESTÃO ATUALIZADAS?
        </StyledDialogTitle>

        <StyledTypography>
          Confira se seus cadastros nas redes sociais estão atualizados, isso nos ajuda a entender melhor a sua rotina e pensar em formas de apoiar o seu trabalho!
        </StyledTypography>

        <StyledDialogActions isMobile={isMobile}>
          <StyledSecondaryButton fullWidth={isMobile} onClick={onClose}>
            FAZER ISSO MAIS TARDE
          </StyledSecondaryButton>
          <StyledButton fullWidth={isMobile} onClick={onConfirm}>
            CONFERIR REDES SOCIAIS
          </StyledButton>
        </StyledDialogActions>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default SocialReminderModal;
